import React from 'react'
import SliderPressRelease from '../../component/slidercomponent/SliderPressRelease'
import SliderOutTeam from '../../component/slidercomponent/SliderOutTeam'

const PressRelease = () => {
  return (
    <>
      {/* <section className="department-one" style={{ marginTop: "-80px" }}>
        <div className="department-one_image" style={{ backgroundImage: 'url(assets/images/background/1.jpg)' }} />
        <div className="auto-container">
          <div className="sec-title light centered" style={{ marginTop: "-70px" }}>
            <div className="sec-title_title">Our Gallery</div>
            <h2 className="sec-title_heading">Our Departments Gallery</h2>
          </div>
          <SliderPressRelease />

        </div>
      </section> */}

      

      <section className="specialist-one" style={{ marginTop: "" }}>
        <div className="specialist-one_pattern" style={{ backgroundImage: 'url(assets/images/background/pattern-13.png)' }} />
        <div className="auto-container">
          <div className="sec-title centered ">
            <br />
            <br />
            <div className="sec-title_title" style={{ textTransform: "capitalize" }}>Our Specialties</div>
            <h2 className="sec-title_heading">Medical departments</h2>
          </div>
          <div className="specialist-info-tabs">
            <div className="specialist-tabs tabs-box">
              <ul className="tab-btns tab-buttons clearfix" style={{ marginTop: "-50px" }}>

                <SliderOutTeam />
              </ul>
              <div className="tabs-content" style={{ marginTop: "-70px" }}>
                <div className="tab active-tab" id="prod-cancer">
                  <div className="content">
                    <div className="row clearfix">

                      <div className="content-column col-lg-6 col-md-12 col-sm-12">
                        <div className="inner-column">
                          <h3 className="specialist-one_title">Why Choose Us</h3>
                          <div className="specialist-one_text">When a patient visits from overseas, he wants his treatment to go smoothly. At Satna Swastik Hospital, we do everything we can to make your stay unforgettable. With an emphasis on the needs of each individual patient, our department of foreign patient care strives to offer you smooth services.</div>
                          <div className="row clearfix">
                            <div className="column col-lg-6 col-md-6 col-sm-12">
                              <ul className="specialist-one_list">
                                <li>Friendly and reliable services</li>
                                <li>Renowned & qualified doctors</li>
                                <li>Use of Latest Technologies</li>
                              </ul>
                            </div>
                            <div className="column col-lg-6 col-md-6 col-sm-12">
                              <ul className="specialist-one_list">
                                <li>Qualified Clinical Team</li>
                                <li>100% Expert Doctors</li>
                                <li>Years of Expertise</li>

                              </ul>
                            </div>
                          </div>
                          {/* <div className="specialist-one_button">
                            <a href="appointment.html" className="theme-btn btn-style-one">
                              <span className="btn-wrap">
                                <span className="text-one">More Detail</span>
                                <span className="text-two">More Detail</span>
                              </span>
                            </a>
                          </div> */}
                        </div>
                      </div>

                      <div className="image-column col-lg-6 col-md-12 col-sm-12">
                        <div className="inner-column">
                          <span className="specialist-one_color-one" />
                          <span className="specialist-one_color-two" />
                          <span className="specialist-one_icon">
                            <img src="assets/images/icons/specialist-1.png" alt />
                          </span>
                          {/* <span className="specialist-one_icon-two">
                            <img src="assets/images/icons/specialist-2.png" alt />
                          </span> */}
                          <div className="specialist-one_image">
                            <img src="assets/img/Choose_2.png" alt style={{borderRadius:"10px"}} />
                          </div>
                          <div className="specialist-one_image-two">
                            <img src="assets/img/Choose_1.png" alt style={{borderRadius:"10px"}} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab" id="prod-liver">
                  <div className="content">
                    <div className="row clearfix">
                      <div className="image-column col-lg-6 col-md-12 col-sm-12">
                        <div className="inner-column">
                          <span className="specialist-one_color-one" />
                          <span className="specialist-one_color-two" />
                          <span className="specialist-one_icon">
                            <img src="assets/images/icons/specialist-1.png" alt />
                          </span>
                          <span className="specialist-one_icon-two">
                            <img src="assets/images/icons/specialist-2.png" alt />
                          </span>
                          <div className="specialist-one_image">
                            <img src="assets/images/resource/department-5.jpg" alt />
                          </div>
                          <div className="specialist-one_image-two">
                            <img src="assets/images/resource/department-6.jpg" alt />
                          </div>
                        </div>
                      </div>
                      <div className="content-column col-lg-6 col-md-12 col-sm-12">
                        <div className="inner-column">
                          <h3 className="specialist-one_title">Cardiology patients evaluated &amp; treated have experienced:</h3>
                          <div className="specialist-one_text">Our diverse group of experts works with you and your primary care provider to attend to every facet of your cardiac care and rehabilitation, including diet, exercise, medication and more. We understand how frightening heart problems can be; how even as you recover physically, a lack of confidence may continue.</div>
                          <div className="row clearfix">
                            <div className="column col-lg-6 col-md-6 col-sm-12">
                              <ul className="specialist-one_list">
                                <li>Heart Attacks</li>
                                <li>Angina</li>
                              </ul>
                            </div>
                            <div className="column col-lg-6 col-md-6 col-sm-12">
                              <ul className="specialist-one_list">
                                <li>Heart Surgery</li>
                                <li>Other Heart Conditions</li>
                              </ul>
                            </div>
                          </div>
                          <div className="specialist-one_button">
                            <a href="appointment.html" className="theme-btn btn-style-one">
                              <span className="btn-wrap">
                                <span className="text-one">More Detail</span>
                                <span className="text-two">More Detail</span>
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab" id="prod-kidney">
                  <div className="content">
                    <div className="row clearfix">
                      <div className="image-column col-lg-6 col-md-12 col-sm-12">
                        <div className="inner-column">
                          <span className="specialist-one_color-one" />
                          <span className="specialist-one_color-two" />
                          <span className="specialist-one_icon">
                            <img src="assets/images/icons/specialist-1.png" alt />
                          </span>
                          <span className="specialist-one_icon-two">
                            <img src="assets/images/icons/specialist-2.png" alt />
                          </span>
                          <div className="specialist-one_image">
                            <img src="assets/images/resource/department-5.jpg" alt />
                          </div>
                          <div className="specialist-one_image-two">
                            <img src="assets/images/resource/department-6.jpg" alt />
                          </div>
                        </div>
                      </div>
                      <div className="content-column col-lg-6 col-md-12 col-sm-12">
                        <div className="inner-column">
                          <h3 className="specialist-one_title">Cardiology patients evaluated &amp; treated have experienced:</h3>
                          <div className="specialist-one_text">Our diverse group of experts works with you and your primary care provider to attend to every facet of your cardiac care and rehabilitation, including diet, exercise, medication and more. We understand how frightening heart problems can be; how even as you recover physically, a lack of confidence may continue.</div>
                          <div className="row clearfix">
                            <div className="column col-lg-6 col-md-6 col-sm-12">
                              <ul className="specialist-one_list">
                                <li>Heart Attacks</li>
                                <li>Angina</li>
                              </ul>
                            </div>
                            <div className="column col-lg-6 col-md-6 col-sm-12">
                              <ul className="specialist-one_list">
                                <li>Heart Surgery</li>
                                <li>Other Heart Conditions</li>
                              </ul>
                            </div>
                          </div>
                          <div className="specialist-one_button">
                            <a href="appointment.html" className="theme-btn btn-style-one">
                              <span className="btn-wrap">
                                <span className="text-one">More Detail</span>
                                <span className="text-two">More Detail</span>
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tab" id="prod-cardiology">
                  <div className="content">
                    <div className="row clearfix">

                      <div className="image-column col-lg-6 col-md-12 col-sm-12">
                        <div className="inner-column">
                          <span className="specialist-one_color-one" />
                          <span className="specialist-one_color-two" />

                          <span className="specialist-one_icon">
                            <img src="assets/images/icons/specialist-1.png" alt />
                          </span>

                          <span className="specialist-one_icon-two">
                            <img src="assets/images/icons/specialist-2.png" alt />
                          </span>
                          <div className="specialist-one_image">
                            <img src="assets/images/resource/department-5.jpg" alt />
                          </div>
                          <div className="specialist-one_image-two">
                            <img src="assets/images/resource/department-6.jpg" alt />
                          </div>
                        </div>
                      </div>

                      <div className="content-column col-lg-6 col-md-12 col-sm-12">
                        <div className="inner-column">
                          <h3 className="specialist-one_title">Cardiology patients evaluated &amp; treated have experienced:</h3>
                          <div className="specialist-one_text">Our diverse group of experts works with you and your primary care provider to attend to every facet of your cardiac care and rehabilitation, including diet, exercise, medication and more. We understand how frightening heart problems can be; how even as you recover physically, a lack of confidence may continue.</div>
                          <div className="row clearfix">
                            <div className="column col-lg-6 col-md-6 col-sm-12">
                              <ul className="specialist-one_list">
                                <li>Heart Attacks</li>
                                <li>Angina</li>
                              </ul>
                            </div>
                            <div className="column col-lg-6 col-md-6 col-sm-12">
                              <ul className="specialist-one_list">
                                <li>Heart Surgery</li>
                                <li>Other Heart Conditions</li>
                              </ul>
                            </div>
                          </div>
                          <div className="specialist-one_button">
                            <a href="appointment.html" className="theme-btn btn-style-one">
                              <span className="btn-wrap">
                                <span className="text-one">More Detail</span>
                                <span className="text-two">More Detail</span>
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tab" id="prod-dental">
                  <div className="content">
                    <div className="row clearfix">

                      <div className="image-column col-lg-6 col-md-12 col-sm-12">
                        <div className="inner-column">
                          <span className="specialist-one_color-one" />
                          <span className="specialist-one_color-two" />

                          <span className="specialist-one_icon">
                            <img src="assets/images/icons/specialist-1.png" alt />
                          </span>

                          <span className="specialist-one_icon-two">
                            <img src="assets/images/icons/specialist-2.png" alt />
                          </span>
                          <div className="specialist-one_image">
                            <img src="assets/images/resource/department-5.jpg" alt />
                          </div>
                          <div className="specialist-one_image-two">
                            <img src="assets/images/resource/department-6.jpg" alt />
                          </div>
                        </div>
                      </div>

                      <div className="content-column col-lg-6 col-md-12 col-sm-12">
                        <div className="inner-column">
                          <h3 className="specialist-one_title">Cardiology patients evaluated &amp; treated have experienced:</h3>
                          <div className="specialist-one_text">Our diverse group of experts works with you and your primary care provider to attend to every facet of your cardiac care and rehabilitation, including diet, exercise, medication and more. We understand how frightening heart problems can be; how even as you recover physically, a lack of confidence may continue.</div>
                          <div className="row clearfix">
                            <div className="column col-lg-6 col-md-6 col-sm-12">
                              <ul className="specialist-one_list">
                                <li>Heart Attacks</li>
                                <li>Angina</li>
                              </ul>
                            </div>
                            <div className="column col-lg-6 col-md-6 col-sm-12">
                              <ul className="specialist-one_list">
                                <li>Heart Surgery</li>
                                <li>Other Heart Conditions</li>
                              </ul>
                            </div>
                          </div>
                          <div className="specialist-one_button">
                            <a href="appointment.html" className="theme-btn btn-style-one">
                              <span className="btn-wrap">
                                <span className="text-one">More Detail</span>
                                <span className="text-two">More Detail</span>
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tab" id="prod-radiation">
                  <div className="content">
                    <div className="row clearfix">

                      <div className="image-column col-lg-6 col-md-12 col-sm-12">
                        <div className="inner-column">
                          <span className="specialist-one_color-one" />
                          <span className="specialist-one_color-two" />

                          <span className="specialist-one_icon">
                            <img src="assets/images/icons/specialist-1.png" alt />
                          </span>

                          <span className="specialist-one_icon-two">
                            <img src="assets/images/icons/specialist-2.png" alt />
                          </span>
                          <div className="specialist-one_image">
                            <img src="assets/images/resource/department-5.jpg" alt />
                          </div>
                          <div className="specialist-one_image-two">
                            <img src="assets/images/resource/department-6.jpg" alt />
                          </div>
                        </div>
                      </div>

                      <div className="content-column col-lg-6 col-md-12 col-sm-12">
                        <div className="inner-column">
                          <h3 className="specialist-one_title">Cardiology patients evaluated &amp; treated have experienced:</h3>
                          <div className="specialist-one_text">Our diverse group of experts works with you and your primary care provider to attend to every facet of your cardiac care and rehabilitation, including diet, exercise, medication and more. We understand how frightening heart problems can be; how even as you recover physically, a lack of confidence may continue.</div>
                          <div className="row clearfix">
                            <div className="column col-lg-6 col-md-6 col-sm-12">
                              <ul className="specialist-one_list">
                                <li>Heart Attacks</li>
                                <li>Angina</li>
                              </ul>
                            </div>
                            <div className="column col-lg-6 col-md-6 col-sm-12">
                              <ul className="specialist-one_list">
                                <li>Heart Surgery</li>
                                <li>Other Heart Conditions</li>
                              </ul>
                            </div>
                          </div>
                          <div className="specialist-one_button">
                            <a href="appointment.html" className="theme-btn btn-style-one">
                              <span className="btn-wrap">
                                <span className="text-one">More Detail</span>
                                <span className="text-two">More Detail</span>
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default PressRelease